import * as e from "react";
import { forwardRef as r } from "react";
const c = r(function(o, t) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...o
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12ZM9 13C6.79086 13 5 14.7909 5 17V18C5 19.1046 5.89543 20 7 20H17C18.1046 20 19 19.1046 19 18V17C19 14.7909 17.2091 13 15 13H9Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  c as Account
};
